import React from 'react';
import { DatePicker, BaasicConfirmModal } from 'core/components';
import _map from 'lodash/map';
import _find from 'lodash/find';
import { defaultTemplate } from 'core/hoc';
import { renderIf, isSome } from 'core/utils';
import moment from 'moment';

function TableFilterDateTemplate({ t, ...props }) {
	const {
		onClose,
		onClear,
		onApply,
		onRemove,
		position: { top, left, tableWrap, startLeftValue },
		form,
		title,
		warningModal,
		columnFilter,
		rootStore,
		format,
		errorMessage,
		checkDatesOnDateChange,
	} = props;
	return (
		<div
			className={startLeftValue < tableWrap ? 'table-filter' : 'table-filter arrow-right'}
			style={{ top: top, left: left }}
		>
			<div className="row padd--bottom--sml">
				<div className="col col-sml-10">
					<h4 className="pull padd--top--tny">{t(title)}</h4>
				</div>
			</div>
			<button
				className="btn btn--med btn--ghost ReactModal__close react-filter-box-close"
				onClick={onClose}
				type="button"
			>
				<i className="fa fa-times"></i>
			</button>
			<div className="clearfix"></div>
			{renderIf(!form.$('dateRangeStart').value && !form.$('dateRangeEnd').value)(
				<DatePicker field={form.$('specificDate')} isFilter={true} format={format} />
			)}
			{renderIf(!form.$('dateRangeStart').value && !form.$('dateRangeEnd').value && !form.$('specificDate').value)(
				<div className="spc--bottom--sml">{t('FILTER.DATEOR')}</div>
			)}
			{renderIf(!form.$('specificDate').value)(
				<section>
					<DatePicker
						field={form.$('dateRangeStart')}
						maxDate={moment(form.$('dateRangeEnd').value, format).toDate()}
						rootStore={rootStore}
						isFilter={true}
						format={format}
						checkDatesOnDateChange={checkDatesOnDateChange}
					/>
					<DatePicker
						field={form.$('dateRangeEnd')}
						minDate={moment(form.$('dateRangeStart').value, format).toDate()}
						rootStore={rootStore}
						isFilter={true}
						format={format}
						checkDatesOnDateChange={checkDatesOnDateChange}
					/>
				</section>
			)}
			{renderIf(isSome(errorMessage))(<p className="type--tny type--color--error">{t(errorMessage)}</p>)}
			<div className="separator--primary spc--bottom--xsml spc--top--xsml"></div>
			<div className="clearfix spc--bottom--sml">
				<button
					disabled={
						((form.$('specificDate').value === '' && form.$('specificDate').value.length == 0) ||
							!moment(form.$('specificDate').value, format).isValid()) &&
						(form.$('dateRangeStart').value == '' ||
							form.$('dateRangeStart').value === undefined ||
							form.$('dateRangeEnd').value == '' ||
							form.$('dateRangeEnd').value === undefined ||
							!moment(form.$('dateRangeStart').value, format).isValid() ||
							!moment(form.$('dateRangeEnd').value, format).isValid())
					}
					className="btn btn--med btn--tertiary table-filter__fullwidth"
					onClick={onApply}
				>
					{t('FILTER.APPLY')}
				</button>
			</div>
			<button disabled={!columnFilter} className="btn btn--med btn--secondary pull" onClick={onRemove}>
				{t('FILTER.REMOVE')}
			</button>
			<button
				disabled={
					form.$('specificDate').value === '' &&
					form.$('specificDate').value.length == 0 &&
					(form.$('dateRangeStart').value == '' || form.$('dateRangeEnd').value == '')
				}
				className="btn btn--med btn--primary push"
				onClick={onClear}
			>
				{t('FILTER.CLEAR')}
			</button>
			<div className="clearfix"></div>
			<BaasicConfirmModal modalParams={warningModal} />
		</div>
	);
}

export default defaultTemplate(TableFilterDateTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/table/TableFilterDateTemplate.jsx